import { toast } from "react-toastify";
import { call, fork, put, takeLatest } from "redux-saga/effects";
import * as actions from "./Actions";
import * as api from "./Api";
import Types from "./Types";

function* getStudentExams({ payload }) {
  try {
    yield put(actions.addStudentExamsLoading(true));
    const result = yield call(api.listAllMainStudentExams, payload);
    yield put(actions.getStudentExamsSuccess(result.data));
  } catch (error) {
    toast.error(error?.response?.data?.message || "Failed to fetch student exams");
    yield put(actions.getStudentExamsFail());
  } finally {
    yield put(actions.addStudentExamsLoading(false));
  }
}

function* redoExam({ payload, action }) {
  try {
    yield put(actions.addStudentExamsLoading(true));
    const result = yield call(api.redoExam, payload);
    toast.success(result.data?.message || "Exam redo request sent successfully");
    yield put(actions.redoExamSuccess(result.data));
    if (action) {
      action();
    }
    // Refresh the list
    yield put(actions.getStudentExamsRequest());
  } catch (error) {
    toast.error(error?.response?.data?.message || "Failed to redo exam");
    yield put(actions.redoExamFail());
  } finally {
    yield put(actions.addStudentExamsLoading(false));
  }
}

export default function* StudentExamsSaga() {
  yield takeLatest(Types.GET_ADMIN_STUDENT_EXAMS_MAIN_REQUEST, getStudentExams);
  yield takeLatest(Types.REDO_EXAM_REQUEST, redoExam);
}

